/*eslint-disable */
import styled from 'styled-components';

export const Page404_Container = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	width: 100vw;
	height: 100vh;
	gap: 20px;

	h1 {
		font-family: 'Pretendard-Bold';
	}
`;

export const Page404_Button = styled.button`
	width: 400px;
	height: 50px;
	font-size: 24px;
	background-color: black;
	color: white;
	cursor: pointer;
`;
